// extracted by mini-css-extract-plugin
export default {"fields":"bot_fields__mEmj2","inputs":"bot_inputs__D9-Yo","grow":"bot_grow__4jwhk","switches":"bot_switches__K8xpW"};